import { FC, memo } from 'react';

import { IconBase, IconBaseProps } from './IconBase';

export const IconNoDataSale: FC<IconBaseProps> = memo(props => {
  return (
    <IconBase {...props} viewBox="0 0 56 56">
      <path
        d="M53.6667 53.6668L2.33342 2.33349"
        stroke="white"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M35 2.3335L51.3333 4.66683L53.6667 21.0002L21 53.6668L2.33333 35.0002L35 2.3335Z"
        stroke="white"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <ellipse
        cx="40.8334"
        cy="15.1667"
        rx="4.66667"
        ry="4.66667"
        stroke="white"
        strokeWidth="2"
        strokeLinejoin="round"
      />
    </IconBase>
  );
});
